@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (isLoaded()) {
    <div class="configuration">
      <app-unit-information (tagInformationUpdated)="updateTaggingDetails($event)" [line]="entityLine()"
        [isOem]="isOem()" [tags]="taggingDetails()" [invalidEntities]="invalidEntities()"
        [engineKey]="getEngineKey()" (valueChanged)="validateUnit()"
        (quantityChanged)="quantityChanged()" [selectionEntities]="selectionEntities()">
      </app-unit-information>
      <app-system-inputs (valueChanged)="validateAndRateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()"
        (unitTypeChanged)="unitTypeChanged()" (systemTypeChanged)="systemTypeChanged()">
      </app-system-inputs>
      <app-indoor-air-quality (valueChanged)="validateUnit()" [selectionEntities]="selectionEntities()"
        [invalidEntities]="invalidEntities()" [engineKey]="getEngineKey()">
      </app-indoor-air-quality>
      <app-direct-drive-performance-input (valueChanged)="validateAndRateUnit()" [engineKey]="getEngineKey()"
        [selectionEntities]="selectionEntities()" [invalidEntities]="invalidEntities()"
        (inputUnitsChanged)="inputUnitsChanged()" [isSureflow]="true"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-input>
      <app-direct-drive-performance-results [selectionEntities]="selectionEntities()" [isSureflow]="true"
        [ratingResponse]="unitRatingResponse()">
      </app-direct-drive-performance-results>
      <app-horizontal-mechanical-connections [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" [imagePrefix]="getImagePrefix()"
        (valueChanged)="validateUnit()">
      </app-horizontal-mechanical-connections>
      <app-horizontal-controls [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-horizontal-controls>
      <app-coil-options [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-coil-options>
      <app-horizontal-primary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-horizontal-primary-valve-package>
      <app-horizontal-secondary-valve-package [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-horizontal-secondary-valve-package>
      <app-horizontal-cabinet-features [selectionEntities]="selectionEntities()" [engineKey]="getEngineKey()"
        [invalidEntities]="invalidEntities()" (valueChanged)="validateUnit()">
      </app-horizontal-cabinet-features>
    </div>
  }
  <div class="prices">
    <app-skus-and-prices [modelImagePath]="unitImagePath()" [messages]="messages()" [skus]="skus()" [sfrEntries]="sfrEntries()"
      [entityLeadTime]="entityLeadTime"
      [configurationLeadTime]="configurationLeadTime()" (sfrFlagChanged)="sfrFlagChanged()">
    </app-skus-and-prices>
  </div>
</div>

